import { useEffect, useRef } from "react";
import { trackPlayer } from "../../@core/services/appService";

// ตัว hook สำหรับ track เวลาเล่นเกม
export function useGameTracking(game, camp) {
    const startTimeRef = useRef(null);

    // เริ่ม session
    const startSession = () => {
        startTimeRef.current = Date.now();
    };

    // ปิด session
    const endSession = () => {
        if (!startTimeRef.current) return;
        const endTime = Date.now();
        const duration = endTime - startTimeRef.current;

        const payload = {
            game_code: game,
            game_camp: camp,
            start_time: new Date(startTimeRef.current).toISOString(),
            end_time: new Date(endTime).toISOString(),
            duration, // ms
        };

        trackPlayer(payload)
        startTimeRef.current = null;
    };

    useEffect(() => {
        // จับตอน user ปิด tab หรือ reload
        const handleUnload = () => {
            endSession();
        };

        window.addEventListener("beforeunload", handleUnload);
        return () => {
            window.removeEventListener("beforeunload", handleUnload);
        };
    }, []);

    return { startSession, endSession };
}
